import * as actionTypes from '../actions/actionTypes';

import { updateObject } from '../../shared/utilities';

const initialState = {
    data: {},
    loading: false,
    error: null,
    posted: false,
    deleting: false,
    deleted: false,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ITEM_ADD_INIT:
            return updateObject(state, { loading: false, posted: false, error: null });

        case actionTypes.ITEM_ADD_START:
            return updateObject(state, { loading: true, error: null });

        case actionTypes.ITEM_ADD_SUCCESS:
            // const newItem = updateObject(action.data, { id: action.id });
            return updateObject(state, {
                loading: false,
                posted: true,
                error: null,
                // data: state.data.concat(newItem)
            });

        case actionTypes.ITEM_ADD_FAIL:
            return updateObject(state, { loading: false, posted: false, error: action.error });

        case actionTypes.ITEM_UPDATE_SUCCESS:
            return updateObject(state, {
                loading: false,
                posted: true,
                error: null,
            });


        case actionTypes.ITEMS_FETCH_START:
            return updateObject(state, { loading: true });

        case actionTypes.ITEMS_FETCH_SUCCESS:
            return updateObject(state, {
                loading: false,
                data: action.data
            });

        case actionTypes.ITEMS_FETCH_FAIL:
            return updateObject(state, { loading: false,  error: action.error });


        case actionTypes.ITEM_DELETE_START:
            return updateObject(state, { deleting: true });

        case actionTypes.ITEM_DELETE_SUCCESS:
           
            return updateObject(state, {
                deleting: false,
                deleted: true,
                error: null,
            });

        case actionTypes.ITEM_DELETE_FAIL:
            return updateObject(state, { deleting: false, deleted: false, error: action.error });

        default:
            return state;
    }
};


export default reducer;
